import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import TestimonialBase, * as TestimonialRecipe from '@segment/matcha/recipes/Testimonial'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import { testimonialData } from './data'

const Testimonial = () => {
  const pageConfig = usePageConfig()
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <StyledTestimonialBase variant="extended">
          <TestimonialRecipe.Base height="500px">
            <TestimonialRecipe.BaseContentSlot>
              <TestimonialRecipe.BaseLogo>{testimonialData.logo}</TestimonialRecipe.BaseLogo>
              <TestimonialRecipe.BaseText>{testimonialData.text}</TestimonialRecipe.BaseText>
            </TestimonialRecipe.BaseContentSlot>
            <TestimonialRecipe.BaseAuthorSlot>
              <TestimonialRecipe.AuthorInfo>
                <TestimonialRecipe.AuthorName>{testimonialData.name}</TestimonialRecipe.AuthorName>
                <TestimonialRecipe.AuthorPosition>{testimonialData.position}</TestimonialRecipe.AuthorPosition>
              </TestimonialRecipe.AuthorInfo>
            </TestimonialRecipe.BaseAuthorSlot>
          </TestimonialRecipe.Base>
          <TestimonialRecipe.Extended>
            <TestimonialRecipe.ExtendedTextSlot>
              <TestimonialRecipe.ExtendedText variant="h3">
                {testimonialData.extendedText}
              </TestimonialRecipe.ExtendedText>
            </TestimonialRecipe.ExtendedTextSlot>
            <TestimonialRecipe.ExtendedButtonSlot>
              <TestimonialRecipe.ExtendedStoryLink>
                <TestimonialRecipe.ExtendedButton
                  size="medium"
                  href={getAbsoluteUrl(testimonialData.extendedLink, pageConfig)}
                  text="Read their story"
                />
              </TestimonialRecipe.ExtendedStoryLink>
            </TestimonialRecipe.ExtendedButtonSlot>
          </TestimonialRecipe.Extended>
        </StyledTestimonialBase>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledTestimonialBase = styled(TestimonialBase)`
  max-width: 1040px;
  margin: 0 auto;
`

export default Testimonial
